import { render, staticRenderFns } from "./userIntegralList.vue?vue&type=template&id=7ddfad64&scoped=true"
import script from "./userIntegralList.vue?vue&type=script&lang=js"
export * from "./userIntegralList.vue?vue&type=script&lang=js"
import style0 from "./userIntegralList.vue?vue&type=style&index=0&id=7ddfad64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddfad64",
  null
  
)

export default component.exports